import { render, staticRenderFns } from "./ApplicationsTab.vue?vue&type=template&id=5602afaa"
import script from "./ApplicationsTab.vue?vue&type=script&lang=js"
export * from "./ApplicationsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports